import { pageLinksBeyond, SITE_PAGE } from '@/features/common/layout/publicPageLinks';
import { usePublicPageLinks } from '@/features/common/layout/usePublicPageLinks';
import type { NavGroupLink } from '@/features/common/types/NavGroupLink';
import { publicLayout, type PublicLayoutKey } from '@/i18n/dictionaries/publicLayout';
import { useTranslation } from '@/i18n/useTranslation';

const BEFORE_PAGES: [string, PublicLayoutKey][] = [
  [SITE_PAGE.presentation, 'footerLinkPresentation'],
];

const AFTER_PAGES: [string, PublicLayoutKey][] = [
  ['/contact', 'footerLinkContactForm'],
  ['/sitemap', 'navSitemap'],
  ['/politici/utilizare', 'footerBottomTerms'],
  ['/politici/confidentialitate', 'footerBottomPrivacy'],
  ['/politici/cookies', 'footerBottomCookies'],
  [SITE_PAGE.accessibility, 'navAccessibilityStatement'],
];

const NAMED_PATHS = [...BEFORE_PAGES, ...AFTER_PAGES].map(([to]) => to);

/**
 * What the header's „Informații” group holds: the categories tor.md §6.1 lists for the public
 * menu that the six primary links do not cover — the presentation, the contact form, the sitemap
 * and the three policies (T143, which found them in the footer only) — plus the accessibility
 * statement and any page an administrator has published since.
 */
export function useInformationLinks(): NavGroupLink[] {
  const { t, language } = useTranslation(publicLayout);
  const pages = usePublicPageLinks();
  const named = ([to, key]: [string, PublicLayoutKey]) => ({ to, label: t(key) });

  return [
    ...BEFORE_PAGES.map(named),
    ...pageLinksBeyond(pages, NAMED_PATHS, language),
    ...AFTER_PAGES.map(named),
  ];
}
